/**
 * CRM Arche Page
 *
 * Route wrapper: ArcheLayout + Routes for the CRM arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../components/ArcheLayout';
import { CRMPage } from './CRMPage';

export function CRMArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/*" element={<CRMPage />} />
      </Routes>
    </ArcheLayout>
  );
}
